import VIPIcon from '../../../assets/svgs/vip.svg?component'
export default function VIPBadge ({ isVIP }: { isVIP: boolean | null | undefined }): JSX.Element | null {
  if (!isVIP) return null
  return (
    <>
      <div title='VIP'>
        <VIPIcon />
      </div>
    </>
  )
}
